import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["visible", "show", "backdrop", "mask", "onHide", "onCancel", "dialogClassName", "wrapClassName", "backdropStyle", "maskStyle", "container", "getContainer", "backdropClosable", "maskClosable", "onExited", "afterClose"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Modal, { destroyFns } from './Modal';
import confirm from './confirm';
import Icon from '../../wui-icon/src';
import { Warning } from "../../wui-core/src";
var isShouldUpdate = Warning.isShouldUpdate;
import { isUndefined } from "lodash-es";

var ModalWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalWrapper, _React$Component);

  var _super = _createSuper(ModalWrapper);

  function ModalWrapper() {
    _classCallCheck(this, ModalWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(ModalWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          visible = _this$props.visible,
          show = _this$props.show,
          backdrop = _this$props.backdrop,
          mask = _this$props.mask,
          onHide = _this$props.onHide,
          onCancel = _this$props.onCancel,
          dialogClassName = _this$props.dialogClassName,
          wrapClassName = _this$props.wrapClassName,
          backdropStyle = _this$props.backdropStyle,
          maskStyle = _this$props.maskStyle,
          container = _this$props.container,
          getContainer = _this$props.getContainer,
          backdropClosable = _this$props.backdropClosable,
          maskClosable = _this$props.maskClosable,
          onExited = _this$props.onExited,
          afterClose = _this$props.afterClose,
          others = _objectWithoutProperties(_this$props, _excluded);

      isShouldUpdate("Modal", this.props);
      var extral = {
        show: isUndefined(visible) ? show : visible,
        backdrop: isUndefined(mask) ? backdrop : mask,
        onHide: isUndefined(onCancel) ? onHide : onCancel,
        onExited: isUndefined(afterClose) ? onExited : afterClose,
        dialogClassName: isUndefined(wrapClassName) ? dialogClassName : wrapClassName,
        backdropStyle: isUndefined(maskStyle) ? backdropStyle : maskStyle,
        container: isUndefined(getContainer) ? container : getContainer,
        backdropClosable: isUndefined(maskClosable) ? backdropClosable : maskClosable
      };
      return /*#__PURE__*/React.createElement(Modal, _extends({}, extral, others));
    }
  }]);

  return ModalWrapper;
}(React.Component);

ModalWrapper.info = function (props) {
  var config = _objectSpread({
    type: 'info',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "uf-i-c"
    }),
    okCancel: false
  }, props);

  return confirm(config);
};

ModalWrapper.success = function (props) {
  var config = _objectSpread({
    type: 'success',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "uf-correct"
    }),
    okCancel: false
  }, props);

  return confirm(config);
};

ModalWrapper.error = function (props) {
  var config = _objectSpread({
    type: 'error',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "uf-exc-c"
    }),
    okCancel: false
  }, props);

  return confirm(config);
};

ModalWrapper.warning = function (props) {
  var config = _objectSpread({
    type: 'warning',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "uf-exc-t"
    }),
    okCancel: false
  }, props);

  return confirm(config);
};

ModalWrapper.confirm = function (props) {
  var config = _objectSpread({
    type: 'confirm',
    okCancel: true
  }, props);

  return confirm(config);
};

ModalWrapper.destroyAll = function () {
  while (destroyFns.length) {
    var close = destroyFns.pop();

    if (close) {
      close();
    }
  }
};

ModalWrapper.Body = Modal.Body;
ModalWrapper.Header = Modal.Header;
ModalWrapper.Title = Modal.Title;
ModalWrapper.Footer = Modal.Footer;
ModalWrapper.Dialog = Modal.ModalDialog;
export default ModalWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/index.js